Vue.component("layout-auth", () => import(/* webpackChunkName: "global" */ "./components/layouts/LayoutAuth.vue"));
Vue.component("layout-modal", () => import(/* webpackChunkName: "global" */ "./components/layouts/LayoutModal.vue"));
Vue.component("layout-page", () => import(/* webpackChunkName: "global" */ "./components/layouts/LayoutPage.vue"));
Vue.component("empty", () => import(/* webpackChunkName: "global" */ "./components/global/Empty.vue"));
Vue.component("alert-bar", () => import(/* webpackChunkName: "global" */ "./components/global/AlertBar.vue"));
Vue.component("headings-block", () => import(/* webpackChunkName: "global" */ "./components/global/HeadingsBlock.vue"));
Vue.component("breadcrumb-separator", () => import(/* webpackChunkName: "global" */ "./components/global/BreadcrumbSeparator.vue"));
Vue.component("loader", () => import(/* webpackChunkName: "global" */ "./components/global/Loader.vue"));
Vue.component("placeholder", () => import(/* webpackChunkName: "global" */ "./components/global/Placeholder.vue"));
Vue.component("columns-row", () => import(/* webpackChunkName: "global" */ "./components/global/ColumnsRow.vue"));
Vue.component("header-bar", () => import(/* webpackChunkName: "global" */ "./components/global/HeaderBar.vue"));
Vue.component("error", () => import(/* webpackChunkName: "global" */ "./components/global/Error.vue"));
Vue.component("csv-uploader", () => import(/* webpackChunkName: "global" */ "./components/global/CSVUploader.vue"));

import cookie from "js-cookie";

Vue.mixin({
	data: function() {
		return {
			get betaAccess() {
				return cookie.get("wonde-beta-access") === "yeah-sure";
			}
		};
	}
});



// WEBPACK FOOTER //
// ./src/global-components.js